// Vendor imports
const ReactRedux = require('react-redux')

// React Hooks

/**
 * @param {string} rolloutKey
 * @returns {boolean}
 */
function useHasRollout(rolloutKey) {
  return ReactRedux.useSelector(state => state.user.hasRollout(rolloutKey))
}

/**
 * @param {string} experimentKey
 * @returns {string|void}
 */
function useGetExperiment(experimentKey) {
  return ReactRedux.useSelector(state => state.user.getExperiment(experimentKey))
}

// React Components

function CheckRollout({ rolloutKey, renderIncluded, renderExcluded }) {
  const isIncluded = useHasRollout(rolloutKey)
  if (isIncluded) {
    return renderIncluded()
  }
  return renderExcluded ? renderExcluded() : null
}

function CheckExperiment({ experimentKey, renderByModifier, renderWithModifier }) {
  const modifier = useGetExperiment(experimentKey)
  // Prefer modifier-specific render functions (when specified)
  if (renderByModifier) {
    if (modifier && renderByModifier[modifier]) {
      return renderByModifier[modifier]()
    }
    // Fall-back to the "control" modifier if no other render function applies
    if (renderByModifier.control) {
      return renderByModifier.control()
    }
  }
  if (renderWithModifier) {
    return renderWithModifier(modifier)
  }
  return null
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  CheckRollout.propTypes = {
    // Values
    rolloutKey: PropTypes.string.isRequired,
    // Render props
    renderExcluded: PropTypes.func,
    renderIncluded: PropTypes.func.isRequired
  }

  CheckExperiment.propTypes = {
    // Values
    experimentKey: PropTypes.string.isRequired,
    // Render props
    renderByModifier: PropTypes.objectOf(PropTypes.func),
    renderWithModifier: PropTypes.func
  }
}

module.exports = {
  // React Hooks
  useHasRollout,
  useGetExperiment,
  // React Components
  CheckRollout,
  CheckExperiment
}
